import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-budget-consumption-report',
  templateUrl: './budget-consumption-report.component.html',
  styleUrls: ['./budget-consumption-report.component.scss']
})
export class BudgetConsumptionReportComponent implements OnInit {

  products: Product[];
  items: MenuItem[];

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
  ];
}
}
